<template>
  <div class="  h-16 cursor-pointer list-group mt-2  w-full flex items-start    flex flex-row justify-center  ">
    <div class="flex flex-col items-start w-full   pt-6   px-6">
      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm  text-gray-900 font-bold "
        >Titre
        </label>
        <input
          id="default-input"
          v-model="title"
          type="text"
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  px-2.5  py-1.5      "
          @input="onInputTitle"
        >
      </div>
      <div class="  mb-4 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm   text-gray-900  font-bold"
        >Description</label>
        <input
          :id="`att-input-description-${properties?.id}`"
          v-model="description"
          type="text"
          class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  px-2.5  py-1.5      "
          @input="onChangeDescription"
        >
      </div>
      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-1 text-sm   text-gray-900  font-bold"
        >Attribute</label>
        <input
          :id="`att-input-data-${properties?.id}`"
          v-model="attribute"
          type="text"
          class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  px-2.5  py-1.5      "
          @input="onChangeAttribute"
        >
      </div>
      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-medium text-gray-900 "
        >Nombre Maximum de document</label>

        <div class="w-full flex flex-col  relative mb-2">
          <div class="w-full flex flex-row w-full px-3 ">
            <div class="start-0 absolute  flex   -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900"
              >1</label>
            </div>
            <div class="start-1/12 absolute flex justify-center -bottom-6">
              <label
                for="steps-range"
                class="block text-2xs font-medium text-gray-900"
              >2</label>
            </div>
            <div class="start-2/12 absolute flex justify-center  -bottom-6">
              <label
                for="steps-range"
                class="block  text-2xs font-medium text-gray-900 "
              >3</label>
            </div>
            <div class="start-3/12 absolute flex justify-center  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >4</label>
            </div>
            <div class="start-4/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >5</label>
            </div>
            <div class="start-5/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >6</label>
            </div>
            <div class="start-6/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >7</label>
            </div>
            <div class="start-7/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >8</label>
            </div>
            <div class="start-8/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >9</label>
            </div>
            <div class="start-9/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >10</label>
            </div>
            <div class="start-10/12 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >11</label>
            </div>
            <div class="end-0 absolute  flex justify-end  -bottom-6">
              <label
                for="steps-range"
                class="block   text-2xs font-medium text-gray-900  "
              >12</label>
            </div>
          </div>
          <input
            id="photo-max-range"
            v-model="max"
            type="range"
            min="1"
            max="12"
            step="1"
            class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer "
            @change="onChangeMax"
          >
        </div>
      </div>




      <div class="  mb-6 w-full text-left">
        <label
          for="default-input"
          class="block mb-2 text-sm font-bold text-gray-900 "
        >Affichage</label>

        <div class="flex flex-col">
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isTitleDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsTitleDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage du Titres</label>
          </div>
          <div class="flex items-center me-4">
            <input
              id="inline-2-checkbox"
              v-model="isDescriptionDisplayed"
              type="checkbox"  
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsDescriptionDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage de la
              description</label>
          </div>  <div class="flex items-center me-4 mt-2">
            <input
              id="inline-2-checkbox"
              v-model="isRowDisplayed"
              type="checkbox"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
              @change="onChangeIsRowDisplayed"
            >
            <label
              for="inline-2-checkbox"
              class="ms-2 text-sm font-medium text-gray-900 "
            >Affichage sur une
              ligne</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
    export default {
        name: 'CodeTableFormComponentDetails',
        props: {
            properties: Object
        },
        data() {

            return {
                title: "",
                description: "",
                format: "",
                mode: "barcopde",
                data: "",
                max: 3,
         
                isReadOnly: false,
                layout: "1-0",
                isTitleDisplayed: false

            }
        },
        watch:
        {
            properties: function () {
                this.title = this.properties?.title;
                this.format = this.properties?.format;
         
                this.max = this.properties?.max
           
                this.layout = this.properties?.layout

                this.isReadOnly = this.properties?.isReadOnly;
                this.isTitleDisplayed = this.properties?.isTitleDisplayed;
                this.data = this.properties?.data;
                this.dataphoto = this.properties?.dataphoto;
            }
        },
        mounted() {
            this.title = this.properties?.title
            this.format = this.properties?.format
            this.layout = this.properties?.layout
        
            this.max = this.properties?.max
       
            this.isReadOnly = this.properties?.isReadOnly;
            this.isTitleDisplayed = this.properties?.isTitleDisplayed;
            this.data = this.properties?.data;
            this.dataphoto = this.properties?.dataphoto;
        },
        methods:
        {
         
            onChangeData: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties",att: 'data', value: this.data })
            },


            onChangeMax: function ( ) {
               
               this.$emit("updateField", { id: this.properties?.id, tab: "properties",att: 'max', value: parseInt(this.max) })
           },

            onChangeIsReadOnly: function () {
                this.$emit("updateField", {id: this.properties?.id, tab: "properties", att: 'isReadOnly', value: this.isReadOnly })
            },
          
            onChangeIsTitleDisplayed: function () {
                this.$emit("updateField", {id: this.properties?.id, tab: "properties", att: 'isTitleDisplayed', value: this.isTitleDisplayed })
            },

            onChangeIsDescriptionDisplayed: function () {
                this.$emit("updateField", {id: this.properties?.id, tab: "properties", att: 'isDescriptionDisplayed', value: this.isTitleDisplayed })
            },

            onChangeLayout: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties", att: 'layout', value: this.layout })
            },

            onClickMode: function (mode) {
                this.mode = mode
                this.$emit("updateField", { id: this.properties?.id, tab: "properties",att: 'mode', value: this.mode })


            },
            onInputTitle: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties",att: 'title', value: this.title })
            },
            onInputDescription: function () {
                this.$emit("updateField", { id: this.properties?.id, tab: "properties",att: 'description', value: this.description })
            }
        }
    }
</script>